var map = {
	"./armor.png": "56b2",
	"./bow.png": "a2b7",
	"./charmed.svg": "00aa",
	"./potion.png": "e909",
	"./potion1.png": "8306",
	"./potion2.png": "8478",
	"./potion3.png": "7b86",
	"./scroll.png": "65e1",
	"./sword.png": "daaf"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "b1ab";